module.exports = __webpack_public_path__ + "static/img/TF.4b201e27.svg";